<script setup lang="ts">
import type { AsyncDataRequestStatus } from '#app'
import type { ProductSmartFilter } from '~/types/api'

const props = defineProps<{
  smartFilters: ProductSmartFilter[]
  status: AsyncDataRequestStatus
}>()

const { getResourceUrl, getImageSrcSet } = useResources()
const localePath = useLocalePath()
</script>

<template>
  <div class="grid gap-5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
    <NuxtLink
      v-for="smartFilter in props.smartFilters"
      :key="smartFilter.nid"
      :to="
        localePath({
          name: 'products-slug',
          params: { slug: smartFilter.urlSlug },
        })
      "
      class="flex items-center gap-2 bg-neutral-100 p-3 no-underline"
    >
      <!-- 
        :src="getResourceUrl(smartFilter.image?.url)"
        :srcset="getImageSrcSet(smartFilter?.image?.url)"
        -->
      <NuxtImg
        :src="'https://ldseating.jagu.dev/file/nodes/product/images/alva-330-sys-br211-f40n1-rm60-bo-pn-v1-po-k-web.webp/600x600'"
        :srcset="'https://ldseating.jagu.dev/file/nodes/product/images/alva-330-sys-br211-f40n1-rm60-bo-pn-v1-po-k-web.webp/600x600'"
        class="aspect-square size-12 object-cover"
      />
      <p class="font-bold text-sm">
        {{ smartFilter.title }}
      </p>
    </NuxtLink>
  </div>
</template>
